// DocuSign action label constants
export const DOCUSIGN_INITIATE_SAGA = 'DOCUSIGN_INITIATE_SAGA';
export const DOCUSIGN_INITIATE_START = 'DOCUSIGN_INITIATE_START';
export const DOCUSIGN_INITIATE_SUCCESS = 'DOCUSIGN_INITIATE_SUCCESS';
export const DOCUSIGN_INITIATE_FAIL = 'DOCUSIGN_INITIATE_FAIL';

export const DOCUSIGN_GET_ENVELOPE_SAGA = 'DOCUSIGN_GET_ENVELOPE_SAGA';
export const DOCUSIGN_GET_ENVELOPE_START = 'DOCUSIGN_GET_ENVELOPE_START';
export const DOCUSIGN_GET_ENVELOPE_SUCCESS = 'DOCUSIGN_GET_ENVELOPE_SUCCESS';
export const DOCUSIGN_GET_ENVELOPE_FAIL = 'DOCUSIGN_GET_ENVELOPE_FAIL';

export const DOCUSIGN_RESET = 'DOCUSIGN_RESET';
